/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';
    
    declare type ModalInformationDirectiveFactoryCb = () => ModalInformationDirective;

    interface IModalInformationDirectiveScopeDef {
        content: string;
        type: string;
        label: string;
    }

    interface IModalInformationDirectiveScope extends ng.IScope {
        content: string;
        type: "information" | "warning" | "error" | "success";
        label: string;
    }


    export class ModalInformationDirective implements ng.IDirective {
        public static $name: string = 'modalInformation';
        public static $inject: string[] = [];

        public restrict: string = 'E';
        public transclude: boolean = false;
        public replace: boolean = true;
        public templateUrl: string = 'decorators/modal-information-directive.html';
        public link: (scope: IModalInformationDirectiveScope) => void;
        public scope: IModalInformationDirectiveScopeDef = {
            content: '@',
            type: '@',
            label: '@',
        };

        /**
         * Factory for the directive
         */
        public static Factory(): ModalInformationDirectiveFactoryCb {
            let directive: ModalInformationDirectiveFactoryCb = () => {
                return new ModalInformationDirective();
            };
            return directive;
        }

        /**
         * Constructor
         */
        constructor() {
            ModalInformationDirective.prototype.link = (scope: IModalInformationDirectiveScope) => {
                // empty for now
            };
        }
    }
}